import { ReactNode } from 'react';

import * as Dialog from '@radix-ui/react-dialog';

import FieldCameraSelect from '@/app/components/FieldCameraSelect';
import FieldMicrophoneSelect from '@/app/components/FieldMicrophoneSelect';
import FieldSpeakerSelect from '@/app/components/FieldSpeakerSelect';

import IconCross from '@/assets/icons/cross.svg?react';

interface DialogSettingsProps {
  children: ReactNode;
}

export default function DialogSettings({ children }: DialogSettingsProps) {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        {children}
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 data-[state=open]:animate-overlayShow" />
        <Dialog.Content className="data-[state=open]:animate-contentShow fixed left-1/2 top-1/2 max-h-[85vh] w-11/12 max-w-md -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-6 shadow-2xl focus:outline-none dark:bg-gray-800 dark:text-gray-100">
          <Dialog.Title className="m-0 font-heading text-base font-bold text-gray-900 dark:text-gray-100">
            Settings
          </Dialog.Title>
          <Dialog.Description className="mb-5 mt-2 text-sm leading-5 text-gray-500 dark:text-gray-400">
            Make changes to your settings here.
          </Dialog.Description>
          <FieldCameraSelect />
          <FieldMicrophoneSelect />
          <FieldSpeakerSelect />
          <div className="mt-6 flex justify-end">
            <Dialog.Close asChild>
              <button className="inline-flex h-9 items-center justify-center rounded-roundings-xs bg-blue-1 px-4 font-medium leading-none text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-1">
                Close
              </button>
            </Dialog.Close>
          </div>
          <Dialog.Close asChild>
            <button
              className="absolute right-3 top-3 inline-flex size-6 appearance-none items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-1 dark:text-gray-400 dark:hover:bg-gray-700"
              aria-label="Close"
            >
              <IconCross />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
